/**
 * Enable Insider Free Shiping Threshold for non-enrolled Insiders
 */ export var INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130 = 'INSIDER_THRESHOLD_FOR_NON_INSIDERS_ENABLED_230130';
